import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

const DeleteButton = styled(Button)(({ theme }) => ({
  root: {
    "&:hover": {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.getContrastText(theme.palette.error.main),
    },
  },
}));

export default DeleteButton;
